import { PoemCommand } from './commandBar';
import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { useRef } from 'react';
import styles from './commandBar.module.css';

export interface CommandProps {
  command: PoemCommand;
  isCollapsed?: boolean;
}

export const Command = ({ command, isCollapsed = false }: CommandProps) => {
  const wrapperRef = useRef<HTMLSpanElement>(null);
  const tooltip = command.tooltip ?? (isCollapsed ? command.label : undefined);

  return (
    <span ref={wrapperRef} style={{ display: 'inline-block' }}>
      {tooltip && (
        <Tooltip
          target={wrapperRef as React.RefObject<HTMLElement>}
          content={tooltip}
          position="bottom"
        />
      )}
      <Button
        type="button"
        onClick={command.onClick}
        text
        size="small"
        disabled={command.disabled}
        aria-label={isCollapsed ? command.label : undefined}
        style={command.disabled ? { pointerEvents: 'none' } : undefined}
      >
        <div className={styles.command}>
          {command.icon && <i className={command.icon}></i>}
          {!isCollapsed && <span>{command.label}</span>}
        </div>
      </Button>
    </span>
  );
};
